import axios, { AxiosRequestConfig, AxiosResponse, Canceler, CancelToken } from 'axios';
import { API_BASE_URL } from '../shared/constants';
import { getUrl } from '../shared/constants/api';
import { IResponseObject } from '../shared/interface';

const axiosInstance = axios.create();
export const cancelToken = axios.CancelToken;
let cancel_req: any;

export { cancel_req };
interface IMiscellaneousRequestParams {
	contentType?: string;
	isPublic?: boolean;
	cancelToken?: CancelToken;
	executor?: (cancel: Canceler) => void;
}

/**
 * get method
 * @param request object containing axios params
 */
const get = (url: string, params: any = {}, token: string, otherData: IMiscellaneousRequestParams = {}) =>
	commonAxios({ method: 'GET', url: getUrl(url, params), token: token, ...otherData });
/**
 * post method
 * @param request object containing axios params
 */
const post = (url: string, params: any = {}, queryParams = {}, token: string, otherData: IMiscellaneousRequestParams = {}) =>
	commonAxios({
		method: 'POST',
		url: getUrl(url, queryParams),
		token: token, 
		data: params,
		...otherData
	});
/**
 * put method
 * @param request object containing axios params
 */
const put = (url: string, params: any = {}, token: string, otherData: IMiscellaneousRequestParams = {}) =>
	commonAxios({ method: 'PUT', url: getUrl(url), token, data: params, ...otherData });

/**
 * deleteRequest method
 * @param request object containing axios params
 */
const deleteRequest = (url: string, params: any = {}, token: string, otherData: IMiscellaneousRequestParams = {}) =>
	commonAxios({ method: 'DELETE', url: getUrl(url), token, data: params, ...otherData });

/**
 * patch method
 * @param request object containing axios params
 */
const patch = (url: string, params: any = {}, token: string, otherData: IMiscellaneousRequestParams = {}) =>
	commonAxios({ method: 'PATCH', url: getUrl(url), token, data: params, ...otherData });

interface IAxiosParams extends IMiscellaneousRequestParams {
	method: string;
	url: string;
	token: string;
	data?: any;
	isAccessTokenRequire?: boolean;
}

/**
 * commonAxios
 * @param object containing method, url, data, access token, content-type, isLogin
 */
const commonAxios = (config: IAxiosParams): Promise<any> => {
	const {
		method,
		url,
		data,
		contentType = 'application/json',
		isPublic = false,
		token,
		// isAccessTokenRequire = true
		executor = (c) => (cancel_req = c)
	} = config;
	const headers: any = {
		'Content-Type': contentType
	};

	// if end point is public than no need to provide access token
	if (!isPublic) {
		// const token = getAccessToken();
		// if (token) {
		// 	headers['x-access-token'] = `${token}`;
		// }
	}

	if (token) {
		headers['X-Access-Token'] = `${token}`;
	} else {
		headers['x-request-language'] = localStorage.getItem('lang') || 'en';
	}

	let body: any = null;
	if (contentType === 'application/json') {
		body = JSON.stringify(data);
	} else {
		body = data;
	}

	const axiosInstanceParams: AxiosRequestConfig = {
		method: method,
		baseURL: API_BASE_URL,
		url: url,
		cancelToken: config.cancelToken || new axios.CancelToken(executor),
		headers: headers,
		data: body
	};

	return new Promise((resolve, reject) => {
		axiosInstance(axiosInstanceParams)
			.then((response: AxiosResponse<IResponseObject<any>>) => {
				resolve(response.data.data);
			})
			.catch((error: any) => {
				reject(error);
			});
	});
};

export { axiosInstance };

const HttpService = {
	get: get,
	post: post,
	put: put,
	deleteRequest: deleteRequest,
	patch: patch
};

export default HttpService;
